<!-- @format -->

<ng-select
  [clearable]="allowClear && !disabled"
  [disabled]="disabled"
  [placeholder]="'SIS_COMPONENTS.SELECT.CODE_SELECTION_EDITOR.SEARCH' | translate"
  [groupBy]="groupByColumn"
  [attr.aria-describedby]="id + '_errors'"
  notFoundText="{{ notFoundKeyToUse() | translate }}"
  (search)="search($event)"
  (blur)="closeOnBlur()"
  (open)="setDefaultCodeOptionsForSearch(true)"
  (close)="setStoredCodeBackAsSelected()"
  [inputAttrs]="{ 'aria-required': required ? 'true' : 'false' }"
  id="{{ id }}"
  labelForId="{{ labelForId }}"
  data-cy="code-select-editor-match"
  [ngModel]="selectedCode"
  (ngModelChange)="selectCode($event)">
  <ng-template ng-label-tmp let-item="item" class="ng-select-match">
    {{ showNumericalCodeValue ? getLastPart(item.urn) + ", " + (item.name | localizedString) : (item.name | localizedString) }}
    <ng-container [ngTemplateOutlet]="lastPartTemplate" [ngTemplateOutletContext]="{ codeObj: item }"></ng-container>
  </ng-template>

  @for (code of codeOptionsResults; track code) {
    <ng-option [value]="code" [disabled]="code.disabled">
      @if (!showAllLanguageVersions) {
        <div title="{{ code.name | localizedString }}" class="ng-select-choices-row-inner-container">
          <span data-cy="code-select-editor-option">{{
            showNumericalCodeValue && !code.isTooManySearchResult
              ? getLastPart(code.urn) + ", " + (code.name | localizedString)
              : (code.name | localizedString)
          }}</span>
          <ng-container [ngTemplateOutlet]="lastPartTemplate" [ngTemplateOutletContext]="{ codeObj: code }"></ng-container>
        </div>
      }
      @if (showAllLanguageVersions) {
        <div title="{{ code.name | localizedString }}" class="ng-select-choices-row-inner-container multiple-language-versions">
          @for (locale of locales; track locale; let last = $last) {
            <span data-cy="code-select-editor-option">{{
              showNumericalCodeValue && !code.isTooManySearchResult ? getLastPart(code.urn) + ", " + code.name[locale] : code.name[locale]
            }}</span>
            @if (!last) {
              <span> / </span>
            }
          }
          <ng-container [ngTemplateOutlet]="lastPartTemplate" [ngTemplateOutletContext]="{ codeObj: code }"></ng-container>
        </div>
      }
    </ng-option>
  }
</ng-select>

<ng-template #lastPartTemplate let-codeObj="codeObj">
  @if (codeObj.universitySpecifier) {
    <span class="additional-info">({{ codeObj.universitySpecifier }})</span>
  }
  @if (showLastPart) {
    <span class="additional-info">{{ getLastPart(codeObj.urn) }}</span>
  }
  @if (codeObj.deprecated) {
    <span class="additional-info" translate>SIS_COMPONENTS.SELECT.DEPRECATED</span>
  }
</ng-template>
